module.exports = __webpack_public_path__ + "img/image3.04bfb15a.png";